/**
 * brunoCV.js — Données structurées du CV de Bruno Llorens
 * Source : /public/assets/bruno-llorens-cv-2027.pdf (extraction 2026-10)
 *
 * Utilisé par :
 *  - /cv (page CV interactif immersif)
 *  - /vcard (mini-CV sections dépliables)
 */

export const CV = {
  nom: 'Bruno Llorens',
  titre: 'Enseignant de la conduite · Moto & Auto',
  sousTitre: 'B · AM · A1 · A2 · A · Formation 125 · Passerelles',
  accroche:
    "Un seul formateur pour couvrir l'ensemble de l'offre permis d'une auto-école. REMC maîtrisé en B comme en moto.",
  contact: {
    tel: '+33 7 82 26 82 00',
    telHref: 'tel:+33782268200',
    email: 'contact@code2roues.fr',
    emailHref: 'mailto:contact@code2roues.fr',
    adresse: 'Saint-Savin (38300) · Nord Isère · Est Lyonnais · Drôme',
    site: 'code2roues.fr',
    siteHref: 'https://code2roues.fr',
    dispo: 'Disponible 7j/7 · 08h00-20h00',
  },
  cles: [
    { icon: '🎯', label: 'Double casquette', value: 'B + 2 Roues' },
    { icon: '📜', label: 'Agrément', value: 'Valide 08/07/2032' },
    { icon: '🏍️', label: 'Spécialité', value: 'ECSR + CCS 2R' },
    { icon: '📍', label: 'Secteur', value: 'Nord Isère · Est Lyonnais · Drôme' },
  ],

  experiences: [
    {
      poste: 'Enseignant Voiture Permis B & Spécialiste 2 Roues',
      entreprise: 'Europermis',
      lieu: 'Isère (38)',
      periode: 'Depuis juin 2026',
      current: true,
      description:
        "Enseignement Voiture (B) Code + Conduite & 2 Roues AM, A1, A2, A, 125, passerelles. Double casquette : formation complète B (REMC, code salle, conduite, éco-conduite) et expertise moto plateau & circulation.",
      realisations: [
        'Suivi individualisé B & 2 Roues',
        'Préparation examens B et 2 Roues',
        'Culture sécurité partagée',
      ],
      tags: ['Permis B', 'Moto', 'REMC', 'Code', 'Éco-conduite'],
    },
    {
      poste: 'Spécialiste 2 Roues (CCS 2R)',
      entreprise: 'Certificat Complémentaire Spécialiste 2 Roues',
      lieu: 'Isère (38)',
      periode: '2026',
      description:
        "Certificat Complémentaire Spécialiste 2 Roues + Qualification B maintenue. Spécialisation réglementaire moto : maniabilité, freinage, trajectoires, tout en conservant l'enseignement voiture. Polyvalence validée.",
      realisations: [
        'AM · A1 · A2 · A · 125 · Passerelles',
        'Maniabilité, freinage d\'urgence, trajectoires',
      ],
      tags: ['CCS 2R', 'Plateau', 'Circulation', 'Passerelle A'],
    },
    {
      poste: 'Enseignant de la Conduite et de la Sécurité Routière',
      entreprise: 'Titre Professionnel ECSR',
      lieu: 'Voiture & 2 Roues',
      periode: '2025 – 2026',
      description:
        'Formation diplômante complète : pédagogie, réglementation, REMC voiture et moto, animation salle code B et 2 Roues, conduite auto et moto.',
      realisations: [
        "Diplôme d'État double compétence B & Moto",
      ],
      tags: ['TP ECSR', 'Diplôme d\'État', 'Pédagogie REMC'],
    },
  ],

  competences: {
    techniques: [
      { nom: 'Permis B', famille: 'auto' },
      { nom: '2 Roues AM / A1 / A2 / A', famille: 'moto' },
      { nom: 'REMC Catégorie B', famille: 'auto' },
      { nom: 'REMC Catégorie A', famille: 'moto' },
      { nom: 'Formation 125 (7h)', famille: 'moto' },
      { nom: 'Passerelle A2 → A', famille: 'moto' },
      { nom: 'Code salle (B & 2R)', famille: 'commun' },
      { nom: 'Conduite auto', famille: 'auto' },
      { nom: 'Éco-conduite', famille: 'auto' },
      { nom: 'Plateau moto', famille: 'moto' },
      { nom: 'Circulation moto', famille: 'moto' },
      { nom: 'Maniabilité moto', famille: 'moto' },
      { nom: 'Freinage d\'urgence', famille: 'commun' },
      { nom: 'Évitement', famille: 'commun' },
      { nom: 'Trajectoires de sécurité', famille: 'moto' },
      { nom: 'Gestion du risque', famille: 'commun' },
      { nom: 'Anticipation', famille: 'commun' },
      { nom: 'Manœuvres examen', famille: 'auto' },
    ],
    pedagogiques: [
      'Pédagogie REMC du débutant à l\'autonomie',
      'Compétences 1 à 4 structurées',
      'Animation dynamique salle code',
      'QCM & corrections pédagogiques',
      'Préparation épreuves plateau & circulation',
      'Suivi individualisé',
      'Auto-évaluation guidée',
      'Cohérence code / conduite',
      'Diagnostic d\'entrée',
      'Briefing structuré avant chaque séance',
      'Progressivité identique B et moto',
    ],
    softSkills: [
      'Polyvalence B + Moto',
      'Optimisation planning',
      'Fidélisation élèves',
      'Flexibilité totale équipe',
      'Humain & sérénité',
      'Rassure l\'élève',
      'Augmente le taux de réussite',
      'Souplesse planning auto-école',
    ],
  },

  prestations: [
    { icon: '🚗', nom: 'Permis B', detail: 'Code, conduite, examen blanc, éco-conduite' },
    { icon: '🏍️', nom: 'Permis A1 / A2', detail: 'Plateau + Circulation complète' },
    { icon: '📜', nom: 'Formation 125 (7h)', detail: '1h théorie + 3h plateau + 3h circulation' },
    { icon: '🔥', nom: 'Passerelle A2 → A', detail: '7h formation après 2 ans de A2' },
    { icon: '🛵', nom: 'Permis AM / BSR', detail: 'Cyclomoteurs et voiturettes' },
    { icon: '🎯', nom: 'Perfectionnement', detail: 'Trajectoires, freinage, évitement' },
    { icon: '🧑‍🏫', nom: 'Renfort moniteur', detail: 'Remplacement ponctuel B ou Moto' },
    { icon: '🎓', nom: 'Préparation examen', detail: 'Examen blanc, gestion du stress' },
  ],

  projets: [
    {
      nom: 'Code2Roues.fr',
      role: 'Fondateur & concepteur pédagogique',
      description:
        "Plateforme pédagogique 2 Roues : ressources vidéos, cours REMC, trajectoires, freinage, éco-conduite. Méthode transposable au permis B. Simulateurs d'épreuves ETM et quiz dynamiques.",
      lien: 'https://code2roues.fr',
      tags: ['Pédagogie', 'Numérique', 'Ressources libres'],
    },
  ],

  temoignages: [
    {
      prenom: 'Manon',
      initiales: 'M',
      formation: 'Plateau A2',
      vehicule: null,
      duree: '8h',
      dureeLabel: 'Préparation',
      resultat: 'Réussite 1ère présentation',
      citation:
        "Préparée au plateau A2 en seulement 8 heures. Validation à la première présentation grâce à une pédagogie claire, un diagnostic précis et une progression adaptée à ses acquis.",
      couleur: 'orange',
    },
    {
      prenom: 'Stan',
      initiales: 'S',
      formation: 'Plateau A2',
      vehicule: null,
      duree: '12h',
      dureeLabel: 'Préparation',
      resultat: 'Réussite 1ère présentation',
      citation:
        "Formé au plateau A2 en 12 heures. Même approche individualisée : briefing structuré, auto-évaluation à chaque étape, et validation par l'inspecteur (IPCSR) dès la première tentative.",
      couleur: 'amber',
    },
    {
      prenom: 'Adeline',
      initiales: 'A',
      formation: 'AM Voiturette',
      vehicule: 'Topolino ⚡ (quadricycle électrique)',
      age: '15 ans',
      duree: 'AM 8h',
      dureeLabel: 'Formation',
      resultat: 'Enfin autonome',
      citation:
        "« Je suis super heureuse de pouvoir enfin être libre dans mes déplacements ! » — Formation AM voiturette sur Topolino électrique, méthode progressive adaptée aux conducteurs débutants dès 14 ans.",
      couleur: 'emerald',
    },
    {
      prenom: 'Charles',
      initiales: 'C',
      formation: 'Conduite accompagnée (AAC)',
      vehicule: 'Permis B · dès 15 ans',
      age: null,
      duree: '20h',
      dureeLabel: 'Formation initiale',
      resultat: 'AAC validée',
      citation:
        "Formation initiale conduite accompagnée réalisée en 20 heures. Validation des 4 compétences REMC Permis B, prêt à rouler en toute sécurité avec son accompagnateur pour les 3 000 km de phase d'apprentissage.",
      couleur: 'blue',
    },
  ],

  chiffres: [
    { valeur: '2', label: 'Qualifications', sub: 'ECSR + CCS 2R' },
    { valeur: '5+', label: 'Catégories', sub: 'B, AM, A1, A2, A' },
    { valeur: '7j/7', label: 'Disponibilité', sub: '08h-20h' },
    { valeur: '2032', label: 'Agrément', sub: 'Jusqu\'au 08/07' },
  ],

  cv_pdf: '/assets/bruno-llorens-cv-2027.pdf',
};
